import { NoneSensor, PrimarySensors, SecondarySensors } from '../components/location-card/location-card.constants';
import { DeviceTypeCode } from '../enums/device-type-code';
import { BaseDeviceConfig } from '../models/monitorsetting';

const VELOCITY_GAIN_SENSORS = [NoneSensor, ...PrimarySensors, ...SecondarySensors];
const VELOCITY_GAIN_EXCLUDED_DEVICES: readonly DeviceTypeCode[] = [
    DeviceTypeCode.TritonSmartBat1,
    DeviceTypeCode.TritonSmartBat2,
    DeviceTypeCode.LongRangeDepth1,
    DeviceTypeCode.LongRangeDepth2,
];

export function isVelocityGainDisabledForSensors(
    devices: readonly Pick<BaseDeviceConfig, 'name'>[] | null | undefined,
): boolean {
    const sensors = devices?.filter((device) =>
        VELOCITY_GAIN_SENSORS.some((sensor) => device.name === sensor.value || device.name === sensor.altValue),
    );

    return (
        sensors?.length === 1 &&
        VELOCITY_GAIN_EXCLUDED_DEVICES.includes(DeviceTypeCode.getDeviceTypeCode(sensors[0].name))
    );
}
